import { createBrowserRouter, Navigate } from "react-router-dom";
import RootNavBar from "../../pages/roots/RootNavBar";
import RootApp from "../../pages/roots/RootApp";
import PrivateRouteV2 from "./PrivateRouteV2";
import NotificationsV2 from "../../pages/private/common/NotificationsV2";
import PlaintrReviewV2 from "../../pages/private/common/PlaintrReviewV2";
import OnboardCpa from "../../components/onboardCpa/OnboardCpa";
import CpaTestV2 from "../../components/onboardCpa/cpaTest/CpaTestV2";
import CpaTestQuestion from "../../components/onboardCpa/cpaTest/CpaTestQuestion";
import ConnectServiceProviderAccount from "../../components/onboardCpa/connectedAccount/ConnectServiceProviderAccount";
import OnboardingLegalV2 from "../../components/onboardCpa/legal/OnboardingLegalV2";
import TaxFilingCreateWizard from "../../components/wizards/TaxFilingCreateWizard";
import NotFound from "../../pages/errors/NotFound";
import FilingMessagesV2 from "../../pages/private/dashboards/filing-dashboard/FilingMessagesV2";
import FilingLogsV2 from "../../pages/private/dashboards/filing-dashboard/FilingLogsV2";
import AccountSettings from "../../pages/private/common/Account/AccountSettings";
import AccountPaymentPayouts from "../../pages/private/common/Account/AccountPaymentPayouts";
import AccountPreferences from "../../pages/private/common/Account/AccountPreferences";
import Faq from "../../pages/publics/faq/Faq.js";
import WhoWeHelp from "../../pages/publics/WhoWeHelp";
import TermsConditions from "../../pages/publics/TermsConditions";
import Privacy from "../../pages/publics/Privacy";
import ServiceAgreement from "../../pages/publics/ServiceAgreement";
import CreateCpa, { action as createCpa } from "../../pages/publics/CreateCpa";
import PublicRoute from "./PublicRoute";
import SignIn from "../../pages/publics/SignIn";
import SignUp from "../../pages/publics/SignUp";
import ActivateAccountPage from "../../pages/publics/ActivateAccountPage";
import ActivationConfirmationPage, {
  action as resendEmailAction,
} from "../../pages/publics/ActivationConfirmationPage";
import ForgotPasswordPage, {
  action as forgotPasswordAction,
} from "../../pages/publics/ForgotPasswordPage";
import ResetPasswordPage, {
  action as resetPasswordAction,
} from "../../pages/publics/ResetPasswordPage";
import { action as logoutUserAction } from "../../pages/private/common/Logout";
import { action as generateCpaTest } from "../../components/onboardCpa/cpaTest/CpaTest";
import ProvideLicenseV2, {
  action as submitLicenseV2,
} from "../../components/onboardCpa/license/ProvideLicenseV2";
import FilingListV2 from "../../pages/private/filings/FilingListV2";
import { tokenLoader } from "../auth";
import Blog from "../../pages/publics/blog/Blog";
import Article from "../../pages/publics/blog/Article";
import AboutUs from "../../pages/publics/AboutUs";
import FilingOverviewV2 from "../../pages/private/dashboards/filing-dashboard/FilingOverviewV2";
import AdminRoute from "./AdminRoute";
import AdminEntry from "../../api/customAdmin/AdminEntry";
import CustomAdminDashboard from "../../pages/private/dashboards/CustomAdminDashboard";
import TaxFilingPublicLandingPage from "../../pages/publics/landings/TaxFiling.js";
import AffiliatesHome from "../../pages/private/affiliates/AffiliatesHome";
import AffiliatesMyLinks from "../../pages/private/affiliates/AffiliatesMyLinks";
import AffiliatesPerformance from "../../pages/private/affiliates/AffiliatesPerformance";
import AffiliatesApplication from "../../pages/private/affiliates/AffiliatesApplication";
import AffiliatesApplicationPersonalInfo from "../../pages/private/affiliates/AffiliatesApplicationPersonalInfo";
import AffiliatesApplicationReview from "../../pages/private/affiliates/AffiliatesApplicationReview";
import AffiliatesApplicationConnectedAccount from "../../pages/private/affiliates/AffiliatesApplicationConnectedAccount";
import ServicesV2 from "../../pages/publics/offerings/ServicesV2.js";
import FilingLayout from "../../pages/private/dashboards/filing-dashboard/layout/FilingLayout.js";
import FilingIdentity from "../../pages/private/dashboards/filing-dashboard/FilingIdentity.js";
import HelpCenter from "../../pages/publics/helpcenter/HelpCenter.js";
import PublicLayout from "../layouts/PublicLayout.js";
import HybridLayout from "../layouts/HybridLayout.js";
import AffiliatePublicLandingPage from "../../pages/publics/landings/Affiliates.js";
import FinancialInsightsHome from "../../pages/private/financial-insights/FinancialInsightsHome.js";
import PersonalTransactions from "../../pages/private/dashboards/finances-dashboard/personal-finances/PersonalTransactions.js";
import RecurringPersonalTransactions from "../../pages/private/dashboards/finances-dashboard/personal-finances/RecurringPersonalTransactions.js";
import PersonalBudgets from "../../pages/private/dashboards/finances-dashboard/personal-finances/PersonalBudgets.js";
import PersonalSpendings from "../../pages/private/dashboards/finances-dashboard/personal-finances/PersonalSpendings.js";
import PersonalOverview from "../../pages/private/dashboards/finances-dashboard/personal-finances/PersonalOverview.js";
import PersonalFinancesLayout from "../../pages/private/dashboards/finances-dashboard/personal-finances/common/PersonalFinancesLayout.js";
import TaxMainLayout from "../../pages/private/dashboards/filing-dashboard/layout/TaxMainLayout.js";
import StandardCheckout from "../../pages/common/checkout/StandardCheckout.js";
import Subscriptions from "../../pages/private/common/Account/Subscriptions.js";
import FinancialInsightsLandingPage from "../../pages/publics/landings/FinancialInsightsLandingPage.js";
import PersonalIncome from "../../pages/private/dashboards/finances-dashboard/personal-finances/PersonalIncome.js";

export const app_router = createBrowserRouter([
  {
    path: "/",
    element: <RootNavBar />,
    errorElement: <NotFound />,
    id: "root",
    loader: tokenLoader,
    children: [
      /**
       * Public pages, that are accesible to logged users
       */
      // RootApp is not inside PublicLayout even when meet the same conditions for guest users, but it break the private profiles
      // since is acting as controller for public/private home
      { index: true, element: <RootApp /> },
      {
        element: <PublicLayout />,
        children: [
          { path: "logout", action: logoutUserAction },
          { path: "services", element: <ServicesV2 /> },
          { path: "who-we-help", element: <WhoWeHelp /> },
          { path: "faq", element: <Faq /> },
          { path: "terms-conditions", element: <TermsConditions /> },
          { path: "privacy-policy", element: <Privacy /> },
          { path: "service-agreement", element: <ServiceAgreement /> },
          { path: "help-center", element: <HelpCenter /> },
          { path: "about-us", element: <AboutUs /> },
        ],
      },
      {
        element: <HybridLayout />,
        children: [
          {
            path: "blog",
            children: [
              {
                index: true,
                element: <Blog />,
              },
              {
                path: "article/:articleId",
                element: <Article />,
              },
            ],
          },
        ],
      },
      { path: "tax", element: <TaxFilingPublicLandingPage /> },
      { path: "affiliate-program", element: <AffiliatePublicLandingPage /> },
      { path: "financial-insights", element: <FinancialInsightsLandingPage /> },

      // Protected pages with PrivateRoute wrapping the elements
      {
        path: "notifications",
        element: (
          <PrivateRouteV2 showRightSidebar={false}>
            <NotificationsV2 />
          </PrivateRouteV2>
        ),
      },
      {
        path: "give-feedback",
        element: (
          <PrivateRouteV2>
            <PlaintrReviewV2 />
          </PrivateRouteV2>
        ),
      },
      {
        path: "onboard",
        id: "onboard",
        children: [
          {
            index: true,
            element: (
              <PrivateRouteV2 showRightSidebar={false}>
                <OnboardCpa />
              </PrivateRouteV2>
            ),
          },
          {
            path: "onboarding-test",
            id: "onboarding-test",
            children: [
              {
                index: true,
                element: (
                  <PrivateRouteV2 showRightSidebar={false}>
                    <CpaTestV2 />
                  </PrivateRouteV2>
                ),
                action: generateCpaTest,
              },
              {
                path: ":testId",
                element: (
                  <PrivateRouteV2 showRightSidebar={false}>
                    <CpaTestQuestion />
                  </PrivateRouteV2>
                ),
              },
            ],
          },
          {
            path: "provide-license",
            id: "provide-license",
            children: [
              {
                index: true,
                element: (
                  <PrivateRouteV2 showRightSidebar={false}>
                    <ProvideLicenseV2 />
                  </PrivateRouteV2>
                ),
                action: submitLicenseV2,
              },
            ],
          },

          {
            path: "connected-account",
            id: "connected-account",
            children: [
              {
                index: true,
                element: (
                  <PrivateRouteV2 showRightSidebar={false}>
                    <ConnectServiceProviderAccount />
                  </PrivateRouteV2>
                ),
              },
            ],
          },
          {
            path: "onboarding-legal",
            id: "onboarding-legal",
            children: [
              {
                index: true,
                element: (
                  <PrivateRouteV2 showRightSidebar={false}>
                    <OnboardingLegalV2 />
                  </PrivateRouteV2>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "help-center",
        element: (
          <PrivateRouteV2 showRightSidebar={false}>
            <HelpCenter />
          </PrivateRouteV2>
        ),
      },
      {
        path: "tax-filing",
        id: "tax-home",
        children: [
          // 1. LIST VIEW GROUP (My Filings / Jobs)
          {
            element: (
              <PrivateRouteV2 showRightSidebar={false}>
                <TaxMainLayout />
              </PrivateRouteV2>
            ),
            children: [
              {
                index: true,
                id: "tax-index",
                element: <FilingListV2 />,
              },
            ],
          },

          // 2. NEW FILING WIZARD (No Menu/Layout needed)
          {
            path: "new-filing",
            id: "tax-new-filing",
            children: [
              {
                index: true,
                element: (
                  <PrivateRouteV2 showRightSidebar={false}>
                    <TaxFilingCreateWizard />
                  </PrivateRouteV2>
                ),
              },
              {
                path: ":filingUuid",
                element: (
                  <PrivateRouteV2 showRightSidebar={false}>
                    <TaxFilingCreateWizard />
                  </PrivateRouteV2>
                ),
              },
            ],
          },

          // 3. INDIVIDUAL FILING GROUP (Overview / Identity / Messages)
          {
            path: "filing/:filingUuid",
            id: "tax-filing-entity",
            element: (
              <PrivateRouteV2 showRightSidebar={false}>
                <FilingLayout />
              </PrivateRouteV2>
            ),
            errorElement: <NotFound />,
            children: [
              {
                index: true,
                element: <FilingOverviewV2 />,
              },
              {
                path: "identity",
                element: <FilingIdentity />,
              },
              {
                path: "messages",
                element: <FilingMessagesV2 />,
              },
              {
                path: "process-status",
                element: <FilingLogsV2 />,
              },
            ],
          },
        ],
      },
      {
        path: "account/settings",
        errorElement: <NotFound />,
        element: (
          <PrivateRouteV2 showRightSidebar={false}>
            <AccountSettings />
          </PrivateRouteV2>
        ),
      },
      {
        path: "account/transactions",
        errorElement: <NotFound />,
        element: (
          <PrivateRouteV2 showRightSidebar={false}>
            <AccountPaymentPayouts />
          </PrivateRouteV2>
        ),
      },
      {
        path: "account/subscriptions",
        errorElement: <NotFound />,
        element: (
          <PrivateRouteV2 showRightSidebar={false}>
            <Subscriptions />
          </PrivateRouteV2>
        ),
      },
      {
        path: "account/preferences",
        errorElement: <NotFound />,
        element: (
          <PrivateRouteV2 showRightSidebar={false}>
            <AccountPreferences />
          </PrivateRouteV2>
        ),
      },
      // {
      //   path: "affiliates",
      //   id: "affiliates-program",
      //   children: [
      //     {
      //       index: true,
      //       element: (
      //         <PrivateRouteV2 showRightSidebar={false}>
      //           <AffiliatesHome />
      //         </PrivateRouteV2>
      //       ),
      //     },
      //     {
      //       path: "application",
      //       children: [
      //         {
      //           index: true,
      //           element: (
      //             <PrivateRouteV2 showRightSidebar={false}>
      //               <AffiliatesApplication />
      //             </PrivateRouteV2>
      //           ),
      //         },
      //         {
      //           path: "personal-information",
      //           element: (
      //             <PrivateRouteV2 showRightSidebar={false}>
      //               <AffiliatesApplicationPersonalInfo />
      //             </PrivateRouteV2>
      //           ),
      //         },
      //         {
      //           path: "review",
      //           element: (
      //             <PrivateRouteV2 showRightSidebar={false}>
      //               <AffiliatesApplicationReview />
      //             </PrivateRouteV2>
      //           ),
      //         },
      //         {
      //           path: "connected-account",
      //           element: (
      //             <PrivateRouteV2 showRightSidebar={false}>
      //               <AffiliatesApplicationConnectedAccount />
      //             </PrivateRouteV2>
      //           ),
      //         },
      //       ],
      //     },
      //     {
      //       path: "my-links",
      //       element: (
      //         <PrivateRouteV2 showRightSidebar={false}>
      //           <AffiliatesMyLinks />
      //         </PrivateRouteV2>
      //       ),
      //     },
      //     {
      //       path: "performance",
      //       element: (
      //         <PrivateRouteV2 showRightSidebar={false}>
      //           <AffiliatesPerformance />
      //         </PrivateRouteV2>
      //       ),
      //     },
      //   ],
      // },
      {
        path: "finances",
        id: "finances",
        children: [
          {
            // If someone types just "/finances", redirect them to personal overview by default
            index: true,
            element: (
              <Navigate to="/finances/personal-finances/overview" replace />
            ),
          },
          {
            path: "insights",
            element: (
              <PrivateRouteV2 showRightSidebar={false}>
                <FinancialInsightsHome />
              </PrivateRouteV2>
            ),
          },
          {
            path: "personal-finances",
            element: (
              <PrivateRouteV2 showRightSidebar={false}>
                <PersonalFinancesLayout />
              </PrivateRouteV2>
            ),
            children: [
              {
                // If they hit "/finances/personal-finances", bounce them to the overview child tab
                index: true,
                element: (
                  <Navigate to="/finances/personal-finances/overview" replace />
                ),
              },
              {
                path: "overview",
                element: <PersonalOverview />,
              },
              {
                path: "transactions",
                element: <PersonalTransactions />,
              },
              {
                path: "recurring-transactions",
                element: <RecurringPersonalTransactions />,
              },
              {
                path: "budgets",
                element: <PersonalBudgets />,
              },
              {
                path: "spendings",
                element: <PersonalSpendings />,
              },
              {
                path: "income",
                element: <PersonalIncome />,
              },
            ],
          },
        ],
      },
      {
        path: "checkout",
        element: (
          <PrivateRouteV2 showRightSidebar={false} showLeftSidebar={false}>
            <StandardCheckout />
          </PrivateRouteV2>
        ),
      },
    ],
  },
  // custom admin
  { path: "custom-admin", element: <AdminEntry /> },
  {
    path: "custom-admin/dashboard",
    element: (
      <AdminRoute>
        <CustomAdminDashboard />
      </AdminRoute>
    ),
  },
  // Sign In / Sign Up / Recovery routes do not have navbar
  {
    path: "create-cpa",
    loader: tokenLoader,
    element: (
      <PublicRoute>
        <CreateCpa />
      </PublicRoute>
    ),
    action: createCpa,
  },
  {
    path: "sign-in",
    loader: tokenLoader,
    element: (
      <PublicRoute>
        <SignIn />
      </PublicRoute>
    ),
  },
  {
    path: "sign-up",
    loader: tokenLoader,
    element: (
      <PublicRoute>
        <SignUp />
      </PublicRoute>
    ),
  },
  {
    path: "forgot-password",
    loader: tokenLoader,
    element: (
      <PublicRoute>
        <ForgotPasswordPage />
      </PublicRoute>
    ),
    action: forgotPasswordAction,
  },
  {
    path: "reset-password/:token",
    loader: tokenLoader,
    element: (
      <PublicRoute>
        <ResetPasswordPage />
      </PublicRoute>
    ),
    action: resetPasswordAction,
  },
  {
    path: "activate/:token",
    loader: tokenLoader,
    element: (
      <PublicRoute>
        <ActivateAccountPage />
      </PublicRoute>
    ),
  },
  {
    path: "activate/confirmation",
    loader: tokenLoader,
    element: (
      <PublicRoute>
        <ActivationConfirmationPage />
      </PublicRoute>
    ),
    action: resendEmailAction,
  },
  // Errors page
  {
    path: "error",
    element: <NotFound />,
  },
  {
    path: "error-404",
    element: <NotFound />,
  },
]);
